import React, { FC, PropsWithChildren, ReactNode, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { ProjectCard } from '../projectCard';
import { DesignerCard } from '../designerCard';
import styled, { css } from 'styled-components';
import { IProjectLight } from '../../common';
import { ProjectEvents } from '../../helpers/projectEvents';
import { LayoutConst } from '../../../core';
import ProjectCardNew from '../projectCard/projectCardNew';
import { useRouteMatch as useRouteMatchOrigin } from "react-router-dom";
import { LinkTo } from "../../constants/linkTo";
import useIsDoubleGrid from "../../hooks/useIsDoubleGrid";
import SortableList, { SortableItem } from 'react-easy-sort';
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import { BookEvents } from '_deziiign/books/core/components/helper/bookEvents';
import { BookCard } from '_deziiign/books/core/components/bookCard';
import { computeBook, computeBookProject } from '_deziiign/books/core/components/helper/types/computed/ComputedBook';
import { ProjectDelegate } from 'project-delegate';
import TeamCard from '../TeamCard/TeamCard';
import { ComputedTeam } from 'shared/helpers/types/computed/ComputedTeam';
import { DesignerCardNew } from "../designerCard/designerCard";
import { ItemType } from 'shared/constants/itemType';
import { isServer } from 'shared/constants/isServer';
import { useRouteMatchSsr } from 'shared/hooks/useRouteMatchSsr';
import { Team } from '@brg/api';
import ChannelCard from '../ChannelCard/ChannelCard';
import AdBlockCard, { getAdBlocks, IAdBlock } from '../AdBlockCard';
import { interleaveAdBlocks } from './interleaveAdBlocks';
import { useProfile } from '@brg/auth';
import { getTeamLink } from 'shared/helpers/getTeamLink';
import { MEDIA } from '@brg/ui';


const useRouteMatch = isServer ? useRouteMatchSsr : useRouteMatchOrigin

export interface GridProps {
  isLoading?: boolean;
  k?: number;
  mobileColumns?: number;
  columns?: number;
  isOpaCard?: boolean;
  inDetailCard?: boolean;
}

export const GridWrapper = styled.div.attrs({ className: 'grid-w' }) <{ mobileColumns: number }>`
  display: grid;
  grid-template-columns: repeat(4, 270px);
  gap: 24px;

  @media (max-width: ${LayoutConst.screen.l}px) {
    display: grid;
    grid-template-columns: repeat(4, 221.25px);
    gap: 19.6px;
  }

  @media (max-width: 940px) {
    display: grid;
    grid-template-columns: repeat(
      ${(props) => props.mobileColumns},
      ${(props) => (props.mobileColumns === 2 ? 'calc(50vw - 24px)' : '100%')}
    );
    row-gap: 19.6px;
    column-gap: ${(props) => (props.mobileColumns === 2 ? '16px' : '0')};
  }
`;


//todo переделать, плохо читается
// вообще не читается ):
export const GridWrapperNew = styled.div.attrs({ className: 'grid-w grid-wrapper-new' }) <{
  isLoading?: boolean,
  inDetailCard?: boolean,
  largeMobOffset?: boolean,
  banFollow?: boolean,
  withoutPaddingBottom?: boolean,
  hasLastProjectMoreAuthors?: boolean,
  mobileColumns?: number,
  isDesignersGrid?: boolean,
  isOpaCard?: boolean,
  columns?: number,
  itemType?: ItemType,
  isAgeytomesh?: boolean,
  isProfile?: boolean,
  isFixedHeight?: boolean,
  isSuperPuperGames?: boolean
}>`
  display: grid;
  justify-content: center;
  justify-items: center;
  grid-template-columns: repeat(${(props) => props.columns ?? 4}, ${LayoutConst.projectCard.l.w + 'px'});
  gap: ${({ inDetailCard }) => inDetailCard ? '32px 24px' : LayoutConst.projectCardGap.l + 'px'};
  grid-auto-flow: dense;
  padding-bottom: ${(props) => props.isProfile ? '0px' : '24px'} !important;
  // padding-top: ${(props) => props.isProfile || props.itemType === ItemType.showcase ? '0px' : '24px'};
  overflow: visible;
  // overflow-y: hidden;
  ${p => p.isFixedHeight && 'height: calc(458px * 5 + 24px * 4);'}

  ${({ banFollow }) => banFollow && css`
      a {
        pointer-events: none;
      }
  `};

  ${({ isOpaCard }) => isOpaCard ? css`
    place-items: flex-start;
  ` : null};

  ${({ columns, itemType, inDetailCard }) => {
    switch (itemType) {
      case ItemType.book:
        return css`
          grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.l.w + 'px'});
          gap: ${LayoutConst.projectCardGap.l + 'px'};
          padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
        `;

      case ItemType.showcase:
        return css`
          grid-template-columns: repeat(${columns ?? 4}, 564px);
          gap: ${LayoutConst.projectCardGap.l + 'px'};
          padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
        `;

      case ItemType.mapItem:
        return css`
          grid-template-columns: repeat(${columns ?? 2}, 1fr);
          gap: ${LayoutConst.projectCardGap.tablet + 'px'};
          padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
        `;

      case ItemType.other:
        return css`
          grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.l.w + 'px'});
          gap: ${inDetailCard ? '40px 24px' : LayoutConst.projectCardGap.l + 'px'};
          padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
        `;

      default:
        return null;
    }
  }}

  @media (max-width: ${LayoutConst.screen.mac13 + 'px'}), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: auto;
    ${({ columns, itemType }) => (itemType && [ItemType.book, ItemType.competition, ItemType.other]?.includes(itemType)) ? css`
      grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.m.w + 'px'});
      gap: ${LayoutConst.projectCardGap.l + 'px'};
      padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
    ` : null};

    ${({ inDetailCard }) => inDetailCard && css`
      gap: 32px 24px; 
    `};
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    // gap: ${LayoutConst.projectCardGap.l + 'px'} ;
    gap: 16px;
    padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};

     ${({ columns, itemType }) => {
    switch (itemType) {
      case ItemType.book:
      case ItemType.competition:
      case ItemType.other:
        return css`
            grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.m.w + 'px'});
     
            padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
          `;
      case ItemType.showcase:
        return css`
            grid-template-columns: repeat(${columns ?? 4}, 450px);
          `;
      default:
        return css`
            grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.projectCard.s.w + 'px'});          
          `
    }
  }};


  @media (max-width: ${LayoutConst.screen.l}px) {
    ${({ columns, itemType }) => {
      if (itemType === ItemType.mapItem) {
        return css`
                  gap: 24px;
                  grid-template-columns: repeat(${columns ?? 4}, 1fr);
                `;
      }
    }
  }
   
    ${({ isSuperPuperGames }) => isSuperPuperGames && css`
        gap: 16px; 
    `};
    
    ${({ isDesignersGrid }) => isDesignersGrid ? css`
      column-gap: ${LayoutConst.projectCardGap.tablet + 'px'};
      row-gap: ${LayoutConst.projectCardGap.l + 8 + 'px'};
    ` : null}

    ${({ inDetailCard }) => inDetailCard && css`
      gap: 24px; 
    `};
  }

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    grid-template-columns: repeat(${(props) => props.columns ?? 4}, ${LayoutConst.projectCard.tablet.w + 'px'});
    gap: ${({ inDetailCard }) => inDetailCard ? '24px' : LayoutConst.projectCardGap.tablet + 'px'};
    padding-bottom: ${LayoutConst.projectCardGap.m + 'px'};

    ${({ columns, itemType }) => (itemType && !!['competition', 'book', 'other']?.includes(itemType)) ? css`
    grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.m.w + 'px'});
    gap: ${LayoutConst.projectCardGap.l + 'px'};
    padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
    
    ` : itemType === ItemType.showcase ? css`
    grid-template-columns: repeat(${columns ?? 4}, 100%);
    ` : itemType === ItemType.mapItem ? css`
      grid-template-columns: repeat(${columns ?? 4}, 1fr);
    `: null}

    ${({ isDesignersGrid }) => isDesignersGrid ? css`
      column-gap: ${LayoutConst.projectCardGap.tablet + 'px'};
      row-gap: ${LayoutConst.projectCardGap.l + 8 + 'px'};
    ` : null}
  }


  @media (max-width: ${LayoutConst.screen.md + 'px'}) {
    ${({ itemType, columns }) => {
    switch (itemType) {
      case ItemType.mapItem:
        return css`
            grid-template-columns: repeat(${columns ?? 4}, 1fr);
            gap: ${LayoutConst.projectCardGap.tablet + 'px'};
          `;
      case ItemType.competition:
        return css`
            grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.projectCard.s.w + 'px'});
            gap: ${LayoutConst.projectCardGap.s + 'px'};
            padding-bottom: ${LayoutConst.projectCardGap.s + 'px'};
          `;
      case ItemType.book:
        return css`
            grid-template-columns: repeat(${columns ?? 4}, calc((100% - 48px) / 4));
            gap: 16px;
            padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
          `;
      case ItemType.other:
        return css`
            grid-template-columns: repeat(${columns ?? 4}, 1fr);
            gap: ${LayoutConst.projectCardGap.s + 'px'};
            padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
          `;
      default:
        return null;
    }
  }}
  }

  @media ${MEDIA.MOBILE} {
    ${({ columns, itemType }) => (itemType && !!['competition']?.includes(itemType)) ? css`
      //grid-template-columns: repeat(${columns ?? 4}, calc(25vw - 22px));
      grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.s.w + 'px'});
      gap: 16px;
      padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
  
  ` : null}

  ${({ columns, itemType }) => (itemType && !!['book']?.includes(itemType)) ? css`
      // grid-template-columns: repeat(${columns ?? 4}, calc(25vw - 10px - 16px + ${LayoutConst.projectCardGap.l / (columns ?? 4)}px));
      grid-template-columns: repeat(${columns ?? 4}, calc((100% - 48px) / 4));
      gap: 16px;
      padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
  
  ` : null}

    ${({ isDesignersGrid, columns, mobileColumns }) => isDesignersGrid ? css`
      column-gap: ${LayoutConst.projectCardGap.tablet + 'px'};
      row-gap: ${LayoutConst.projectCardGap.l + 8 + 'px'};
      ${mobileColumns === 2 ? css`
        grid-template-columns: repeat(2, minmax(0, 1fr));
      ` : css`
        grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.s.w + 'px'});
      `}
    ` : null}
  }
  ${({ hasLastProjectMoreAuthors }) => hasLastProjectMoreAuthors ? css`
    @media (max-width: ${LayoutConst.screen.md + 'px'}) {
      margin-bottom: 48px;
    }
    @media (max-width: ${LayoutConst.screen.s + 'px'}) {
      margin-bottom: 0;
      padding-bottom: 0 !important;
    }
` : null}

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {

    ${({ isOpaCard, columns, itemType }) => isOpaCard ? css`
      grid-template-columns: repeat(2, 362px);
      gap: 16px;
    `
    : itemType === ItemType.other ? css`
      grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.projectCard.xs.w + 'px'});
      gap: ${16 + 'px'};
      padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
    ` : itemType === ItemType.book ? css`
      grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.projectCard.xs.w + 'px'});
      gap: ${LayoutConst.projectCardGap.tablet + 'px'};
      padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
    ` : css`
      grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.projectCard.xs.w + 'px'});
      gap: ${LayoutConst.projectCardGap.tablet + 'px'};
      padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
    `};

    ${({ isDesignersGrid, columns, mobileColumns }) => isDesignersGrid ? css`
      column-gap: ${LayoutConst.projectCardGap.tablet + 'px'};
      row-gap: ${LayoutConst.projectCardGap.l + 8 + 'px'};
      ${mobileColumns === 2 ? css`
        grid-template-columns: repeat(2, minmax(0, 1fr));
      ` : css`
        grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.s.w + 'px'});
      `}
    ` : null}
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
    ${({ isOpaCard, columns, itemType, mobileColumns, isDesignersGrid }) =>
    isDesignersGrid && mobileColumns === 2 ? css`
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: ${LayoutConst.projectCardGap.s + 'px'};
  ` : itemType === ItemType.showcase ? css`
    grid-template-columns: repeat(${columns ?? 4}, 100%);
  `: itemType === ItemType.other ? css`
    grid-template-columns: repeat(2, calc(50vw - 15px));
    gap: ${LayoutConst.projectCardGap.s + 'px'};
    padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
  ` : itemType === ItemType.competition ? css`
      grid-template-columns: repeat(
      ${mobileColumns},
      ${mobileColumns === 2 ? 'calc(50vw - 15px)' : '100%'}
    );
    gap: ${mobileColumns === 2 ? 16 : 24}px 10px;
  ` : css`
    grid-template-columns: repeat(
      ${mobileColumns},
      ${mobileColumns === 2 ? 'calc(50vw - 15px)' : '100%'}
    );
    gap: ${mobileColumns === 2 ? 16 : 24}px 10px;
    `}
    justify-content: center;
    justify-items: center;
  }

  ${({ largeMobOffset }) => largeMobOffset && css`
    padding-bottom: 100px !important;
  `};
  
  ${({ withoutPaddingBottom }) => withoutPaddingBottom && css`
    padding-bottom: 0!important;
  `}
`;

export const SortableGridWrapperNew = styled.div<{ mobileColumns?: number, itemType?: string }>`

  .sortable-projects-grid {
    user-select: none;
    display: grid;
    ${({ itemType }) => itemType === ItemType.book ? css`
      grid-template-columns: repeat(4, ${LayoutConst.bookCard.l.w + 'px'});
      gap: ${LayoutConst.projectCardGap.l + 'px'};
    ` : css`
      grid-template-columns: repeat(4, ${LayoutConst.projectCard.l.w + 'px'});
      gap: ${LayoutConst.projectCardGap.l + 'px'};
    `}

    .sortable-projects-grid-item {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      color: white;
      cursor: grab;
      user-select: none;
      z-index: 1;
    }

    .sortable-projects-grid-dragged {
      opacity: 0.5;
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ itemType }) => itemType === ItemType.book ? css`
    .sortable-projects-grid {
      grid-template-columns: repeat(4, ${LayoutConst.bookCard.m.w + 'px'});
      gap: ${LayoutConst.projectCardGap.l + 'px'};
    }
    ` : null}
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    .sortable-projects-grid {
      ${({ itemType }) => itemType === ItemType.book ? css`
        grid-template-columns: repeat(4, ${LayoutConst.bookCard.m.w + 'px'});
        gap: ${LayoutConst.projectCardGap.l + 'px'};
      ` : css`
        grid-template-columns: repeat(4, ${LayoutConst.projectCard.m.w + 'px'});
        gap: ${LayoutConst.projectCardGap.tablet + 'px'};
      `}
    }
  }

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    .sortable-projects-grid {
      ${({ itemType }) => itemType === ItemType.book ? css`
      grid-template-columns: repeat(4, ${LayoutConst.bookCard.m.w + 'px'});
      gap: ${LayoutConst.projectCardGap.l + 'px'};
    ` : css`
      grid-template-columns: repeat(4, ${LayoutConst.projectCard.m.w + 'px'});
      gap: ${LayoutConst.projectCardGap.m + 'px'};
    `}
    }
  }

  @media (max-width: ${LayoutConst.screen.md + 'px'}) {
    .sortable-projects-grid {
      ${({ itemType }) => itemType === ItemType.book ? css`
      grid-template-columns: repeat(4, ${LayoutConst.bookCard.m.w + 'px'});
      gap: ${LayoutConst.projectCardGap.l + 'px'};
    ` : css`
      grid-template-columns: repeat(4, ${LayoutConst.projectCard.s.w + 'px'});
      gap: ${LayoutConst.projectCardGap.s + 'px'};
    `}
    } 
  }

  @media ${MEDIA.MOBILE} {
    .sortable-projects-grid {
      ${({ itemType }) => itemType === ItemType.book ? css`
      grid-template-columns: repeat(4, ${LayoutConst.bookCard.s.w + 'px'});
      gap: ${LayoutConst.projectCardGap.m + 'px'};
    ` : css`
      grid-template-columns: repeat(4, ${LayoutConst.projectCard.s.w + 'px'});
      gap: ${LayoutConst.projectCardGap.s + 'px'};
    `}
    } 
  }
  @media (max-width: ${LayoutConst.screen.s + 'px'}) {
    .sortable-projects-grid {
      ${({ itemType, mobileColumns }) => itemType === ItemType.book ? css`
        grid-template-columns: repeat(${mobileColumns}, ${(mobileColumns === 2 ? 'calc(50vw - 15px)' : '100%')});
        gap: ${mobileColumns === 2 ? 16 : 24}px 10px;
      ` : css`
        grid-template-columns: repeat(4, ${LayoutConst.projectCard.s.w + 'px'});
        gap: ${LayoutConst.projectCardGap.s + 'px'};
      `}
    }
  }

`;

export const GridHseNews = styled.div`
    display: grid;
    grid-template-columns: repeat(3, calc((100% - ${LayoutConst.projectCardGap.l * 2 + 'px'} ) / 3 ));
    gap: ${LayoutConst.projectCardGap.l + 'px'};

    @media (min-width: 320px) {
        grid-template-columns: repeat(1, calc(100vw - 32px));
        gap: 24px;
    }

    @media (min-width: ${LayoutConst.screen.s + 'px'}) {
        grid-template-columns: repeat(2, calc((100% - ${LayoutConst.projectCardGap.s + 'px'}) / 2 ));
        gap: ${LayoutConst.projectCardGap.s + 'px'};
    }

    @media (min-width: ${LayoutConst.screen.m + 'px'}) {
        grid-template-columns: repeat(3, calc((100% - ${LayoutConst.projectCardGap.m * 2 + 'px'} ) / 3 ));
        gap: ${LayoutConst.projectCardGap.m + 'px'};
    }

    @media (min-width: ${LayoutConst.screen.l + 'px'}) {
        grid-template-columns: repeat(3, calc((100% - ${LayoutConst.projectCardGap.l * 2 + 'px'} ) / 3 ));
        gap: ${LayoutConst.projectCardGap.l + 'px'};
    }
`;

/**
 * **ProjectsGrid** - сетка проектов. Содержит переключение isLoading для отображения UX анимации
 *
 * @param mobileColumns
 * @param isLoading
 * @param children
 * @param projects
 * @param k
 * @param isEditable
 * @param handlers
 */
export const ProjectsGrid: FC<
  React.PropsWithChildren<GridProps & { projects?: IProjectLight[]; isEditable?: (project: IProjectLight) => boolean } & ProjectEvents>
> = ({ mobileColumns, isLoading, children, projects, k, isEditable, ...handlers }) => {
  if (isLoading) {
    return (
      <GridWrapper mobileColumns={mobileColumns ?? 1}>
        {Array(k ?? 8)
          .fill('')
          .map((value, index) => (
            <ProjectCard key={index} isLoading={true} />
          ))}
      </GridWrapper>
    );
  }
  return (
    <GridWrapper mobileColumns={mobileColumns ?? 1}>
      {projects
        ? projects.map((value) => (
          <ProjectCard isEditable={isEditable?.(value)} key={value.identifier} {...value} {...handlers} />
        ))
        : null}
      {children}
    </GridWrapper>
  );
};

type ProjectsGridNewPropsT = ProjectEvents & BookEvents & GridProps & {
  isDraggable?: boolean;
  onSortEnd?: (projectId: string, newIndex: number) => void;
  isModal?: boolean;
  projects?: IProjectLight[];
  isEditable?: (project: IProjectLight) => boolean;
  isDeletable?: (project: IProjectLight) => boolean;
  isRemovableFromBook?: boolean;
  onRemoveFromBook?: (projectId: string) => void;
  isCanNotParticipate?: boolean;
  onNotParticipate?: (projectId: string) => void;
  onProjectClick?: (project: IProjectLight, e?: any) => void;
  linkPrefix?: any;
  isAgeytomesh?: boolean;
  withoutRepost?: boolean;
  withoutPaddingBottom?: boolean;
  isCanNotBeDraft?: boolean;
  isCanNotBeBookmark?: boolean;
  itemType?: string;
  banFollow?: boolean;
  largeMobOffset?: boolean;
  isMobileMoreVisible?: boolean;
  isFixedHeight?: boolean;
  isSuperPuperGames?: boolean;
  currentTeam?: Team;
  currentTab?: string;
  forceOneColumn?: boolean;
  showAnnotations?: boolean;
  isHeadCommentsVisibleLocal?: boolean;
  currentCompetitionId?: string;
};

type TeamGridProps = ProjectEvents & GridProps & {
  teams: ComputedTeam[];
  isDraggable?: boolean;
  onSortEnd?: (teamId: string, newIndex: number) => void;
  isEditable?: boolean;
  isDeletable?: (project: Team) => boolean;
  linkPrefix?: any;
  onTeamClick?: (team?: ComputedTeam, e?: any, openInMedia?: boolean) => void;
  hasLinks?: boolean;
  contextName?: string;
  entityType?: string;
  isFixedHeight?: boolean;
  currentTeam?: Team;
  isMe?: boolean;
  currentTab?: string;
  isOuterOrganizationShowcase?: boolean;
}

type ChannelsGridProps = ProjectEvents & GridProps & {
  teams: ComputedTeam[];
  isDraggable?: boolean;
  onSortEnd?: (teamId: string, newIndex: number) => void;
  isEditable?: boolean;
  isDeletable?: (project: Team) => boolean;
  linkPrefix?: any;
  onTeamClick?: (team?: ComputedTeam, e?: any, openInMedia?: boolean) => void;
  hasLinks?: boolean;
  contextName?: string;
  entityType?: string;
  isFixedHeight?: boolean;
  isParticipant?: boolean;
}

export const ProjectsGridNew: FC<PropsWithChildren<ProjectsGridNewPropsT>> = ({
  mobileColumns,
  forceOneColumn,
  columns,
  isLoading,
  children,
  projects,
  k,
  isEditable,
  isDeletable,
  isRemovableFromBook,
  onRemoveFromBook,
  isCanNotParticipate,
  isMobileMoreVisible,
  onNotParticipate,
  onProjectClick,
  isModal,
  isDraggable,
  onSortEnd,
  isCanNotBeDraft,
  isCanNotBeBookmark,
  withoutRepost,
  linkPrefix,
  isAgeytomesh,
  withoutPaddingBottom,
  largeMobOffset,
  itemType,
  banFollow,
  isFixedHeight,
  isSuperPuperGames,
  currentTeam,
  currentTab,
  showAnnotations,
  isHeadCommentsVisibleLocal,
  currentCompetitionId,
  ...handlers
}) => {
  const isDoubleGrid = useIsDoubleGrid({ forceOneColumn });
  const [projectsSource, setProjectsSource] = useState<IProjectLight[]>([]);
  const isProfile = !!useRouteMatch(LinkTo.designer);
  const hasLastProjectMoreAuthors = projectsSource?.[projectsSource.length - 1]?.coAuthorIds.length > 0

  useEffect(() => {
    setProjectsSource(projects ?? []);
  }, [projects])

  const adBlocks = useMemo<IAdBlock[]>(
    () => (!currentTeam || isProfile ? [] : getAdBlocks(currentTeam as any, currentTab)),
    [currentTeam, currentTab, isProfile],
  );

  const renderAdCard = useCallback((block: IAdBlock, key: string) => (
    <AdBlockCard
      key={key}
      team={currentTeam}
      itemType={itemType}
      currentTab={currentTab}
      fullWidth={showAnnotations}
      adBlock={block}
    />
  ), [currentTeam, itemType, currentTab, showAnnotations]);

  const onProjectsSortEnd = useCallback((oldIndex: number, newIndex: number): void => {
    const project = projectsSource[oldIndex];
    setProjectsSource(arrayMoveImmutable(projectsSource, oldIndex, newIndex));
    onSortEnd?.(project.identifier, newIndex);
  }, [projectsSource, onSortEnd]);

  if (isLoading) {
    return (
      <GridWrapperNew isProfile={isProfile} isLoading={isLoading} mobileColumns={isDoubleGrid ? 2 : 1} columns={columns} itemType={itemType as any}>
        {Array(k === undefined ? 8 : k).fill('').map((_, index) => (
          <ProjectCardNew key={index} isLoading={isLoading} itemType={itemType} />
        ))}
      </GridWrapperNew>
    );
  }

  if (isDraggable) {
    return (
      <SortableGridWrapperNew mobileColumns={isDoubleGrid ? 2 : 1} itemType={itemType}>
        <SortableList onSortEnd={onProjectsSortEnd} className="sortable-projects-grid" draggedItemClassName="sortable-projects-grid-dragged">
          {projectsSource?.map((value) => (
            <SortableItem key={value.identifier} >
              <div className="sortable-projects-grid-item">
                {!value.isBook ?
                  <ProjectCardNew
                    project={value as any}
                    isLoading={isLoading}
                    isEditable={isEditable?.(value)}
                    isDeletable={isDeletable?.(value)}
                    isRemovableFromBook={isRemovableFromBook}
                    onProjectClick={onProjectClick ? (projectId?: string, e?: any) => onProjectClick(value, e) : undefined}
                    isModal={isModal}
                    withoutRepost={withoutRepost}
                    isMobileMoreVisible={isMobileMoreVisible}
                    isRejected={ProjectDelegate.isRejectedProject(value)}
                    isHeadCommentsVisibleLocal={isHeadCommentsVisibleLocal}
                    key={value.identifier}
                    onRemoveFromBook={onRemoveFromBook}
                    linkPrefix={linkPrefix ? linkPrefix : undefined}
                    isCanNotParticipate={isCanNotParticipate}
                    isCanNotBeDraft={isCanNotBeDraft}
                    isCanNotBeBookmark={isCanNotBeBookmark}
                    onNotParticipate={onNotParticipate}
                    itemType={itemType}
                    {...value}
                    {...handlers}
                  /> :
                  // @ts-ignore
                  <BookCard
                    book={computeBookProject(value as any) as any}
                    key={value.identifier}
                    {...computeBook(computeBookProject(value as any))}
                    isCanNotParticipate={isCanNotParticipate}
                    isCanNotBeDraft={isCanNotBeDraft}
                    itemType={itemType}
                    onNotParticipate={onNotParticipate}
                    isCanNotBeBookmark={isCanNotBeBookmark}
                  />}
              </div>
            </SortableItem>
          ))}
          {children}
        </SortableList>
      </SortableGridWrapperNew>
    );
  }

  const mobileColumnsWrapper = showAnnotations ? 2 :
    isDoubleGrid ? 2 : 1

  const hasProjectsProp = (projectsSource?.length ?? 0) > 0;
  const gridItems: ReactNode[] = hasProjectsProp
    ? (projectsSource ?? []).map((value) => (!value.isBook ? (
      <ProjectCardNew
        isLoading={isLoading}
        project={value as any}
        isEditable={isEditable?.(value)}
        isDeletable={isDeletable?.(value)}
        isHeadCommentsVisibleLocal={isHeadCommentsVisibleLocal}
        currentCompetitionId={currentCompetitionId}
        withoutRepost={withoutRepost}
        isRejected={ProjectDelegate.isRejectedProject(value)}
        onProjectClick={onProjectClick ? (_projectId?: string, e?: any) => onProjectClick(value, e) : undefined}
        isModal={isModal}
        isMobileMoreVisible={isMobileMoreVisible}
        key={value.identifier}
        linkPrefix={linkPrefix ? linkPrefix : undefined}
        isCanNotParticipate={isCanNotParticipate}
        onNotParticipate={onNotParticipate}
        isCanNotBeDraft={isCanNotBeDraft}
        isCanNotBeBookmark={isCanNotBeBookmark}
        itemType={itemType}
        onUpdate={handlers.onUpdate}
        {...value}
        {...handlers}
      />
    ) : (
      // @ts-ignore
      <BookCard
        book={computeBookProject(value as any) as any}
        key={value.identifier}
        {...computeBook(computeBookProject(value as any))}
        isCanNotParticipate={isCanNotParticipate}
        onNotParticipate={onNotParticipate}
        isCanNotBeDraft={isCanNotBeDraft}
        itemType={itemType}
        onUpdate={handlers.onUpdate}
      />
    )))
    : React.Children.toArray(children);

  return (
    <GridWrapperNew
      largeMobOffset={largeMobOffset}
      isProfile={isProfile}
      banFollow={banFollow}
      withoutPaddingBottom={withoutPaddingBottom}
      hasLastProjectMoreAuthors={hasLastProjectMoreAuthors}
      mobileColumns={mobileColumnsWrapper}
      columns={columns}
      isAgeytomesh={isAgeytomesh}
      itemType={itemType as any}
      isSuperPuperGames={isSuperPuperGames}
    >
      {interleaveAdBlocks(gridItems, adBlocks, renderAdCard)}
      {hasProjectsProp ? children : null}
    </GridWrapperNew>
  );
};

export const NewsGrid: FC<React.PropsWithChildren<GridProps & { isEditable?: (project: IProjectLight) => boolean } & ProjectEvents>> = ({ isLoading, children, k }) => {
  if (isLoading) {
    return (
      <GridHseNews>
        {Array(k ?? 3)
          .fill('')
          .map((value, index) => (
            <ProjectCardNew key={index} isLoading={true} />
          ))}
      </GridHseNews>
    );
  }
  return (
    <GridHseNews>
      {children}
    </GridHseNews>
  );
};

export const DesignersGrid: FC<React.PropsWithChildren<GridProps>> = ({ mobileColumns, isLoading, children, k }) => {
  if (isLoading) {
    return (
      <GridWrapper mobileColumns={mobileColumns ?? 1}>
        {Array(k ?? 8)
          .fill('')
          .map((value, index) => (
            <DesignerCard key={index} isLoading={true} />
          ))}
      </GridWrapper>
    );
  }
  return <GridWrapper mobileColumns={mobileColumns ?? 1}>{children}</GridWrapper>;
};

export const DesignersGridNew: FC<React.PropsWithChildren<GridProps>> = ({ mobileColumns, isLoading, isOpaCard, children, inDetailCard, k }) => {
  const isProfile = !!useRouteMatch(LinkTo.designer);
  if (isLoading) {
    return (
      <GridWrapperNew isDesignersGrid mobileColumns={mobileColumns} isOpaCard={isOpaCard}>
        {Array(k ?? 8)
          .fill('')
          .map((value, index) => (
            <DesignerCardNew key={index} isLoading={true} isOpaCard={isOpaCard} />
          ))}
      </GridWrapperNew>
    );
  }
  return <GridWrapperNew isProfile={isProfile} isDesignersGrid inDetailCard={inDetailCard} mobileColumns={mobileColumns} isOpaCard={isOpaCard}>{children}</GridWrapperNew>;
};

export const TeamGrid: FC<TeamGridProps> = ({
  teams: teamsRaw,
  contextName,
  isDraggable,
  onSortEnd,
  isEditable,
  isDeletable,
  onTeamClick,
  linkPrefix,
  isMe,
  hasLinks,
  columns,
  entityType,
  isFixedHeight,
  isLoading,
  currentTeam,
  currentTab,
  isOuterOrganizationShowcase,
  onUpdate,
  ...handlers
}) => {
  const isDoubleGrid = useIsDoubleGrid();
  const isProfile = !!useRouteMatch(LinkTo.designer);
  const isMadeByMediiia = !!useRouteMatch('/made_by_mediiia');
  const teams = useMemo(() => {
    return teamsRaw;
  }, [isMadeByMediiia, teamsRaw]);

  const adBlocks = useMemo<IAdBlock[]>(
    () => (!currentTeam || isProfile ? [] : getAdBlocks(currentTeam as any, currentTab)),
    [currentTeam, currentTab, isProfile],
  );

  if (isLoading) {
    return <ProjectsGridNew isLoading />
  }

  const renderAdCard = (block: IAdBlock, key: string) => (
    <AdBlockCard
      key={key}
      team={currentTeam}
      itemType={entityType}
      currentTab={currentTab}
      adBlock={block}
    />
  );

  const teamItems = (teams ?? []).map((team) => (
    <TeamCard
      team={team as any}
      isEditable={false}
      isMe={isMe}
      isDeletable={false}
      isRejected={false}
      onTeamClick={onTeamClick}
      isModal={false}
      disableHover={team?.hiddenHover}
      key={team.teamId}
      linkPrefix={linkPrefix ? linkPrefix : undefined}
      linkTo={getTeamLink(team, hasLinks)}
      entityType={entityType}
      {...team}
      {...handlers}
      contextName={contextName}
      isOuterOrganizationShowcase={isOuterOrganizationShowcase}
      isProfile={isProfile}
      onUpdate={onUpdate}
    />
  ));

  return (
    <GridWrapperNew isFixedHeight={isFixedHeight} isProfile={isProfile} mobileColumns={isDoubleGrid ? 2 : 1} columns={columns}>
      {interleaveAdBlocks(teamItems, adBlocks, renderAdCard)}
    </GridWrapperNew>
  )
}

//todo чем отличается от TeamGrid?
export const ChannelsGrid: FC<ChannelsGridProps> = ({
  teams: teamsRaw,
  contextName,
  isDraggable,
  isParticipant,
  onSortEnd,
  isEditable,
  isDeletable,
  onTeamClick,
  linkPrefix,
  hasLinks,
  columns,
  entityType,
  isFixedHeight,
  ...handlers
}) => {
  const isDoubleGrid = useIsDoubleGrid();
  const isProfile = !!useRouteMatch(LinkTo.designer);
  const isMadeByMediiia = !!useRouteMatch('/made_by_mediiia');
  const profile = useProfile();

  const teams = useMemo(() => {
    return teamsRaw;
  }, [isMadeByMediiia, teamsRaw]);

  const getInnerLink = useCallback((team: ComputedTeam) => {
    return process.env.REACT_APP_URL_MEDIIIA_COM + '/teams/' + team?.teamId
  }, [hasLinks])

  return (
    <GridWrapperNew isFixedHeight={isFixedHeight} isProfile={isProfile} mobileColumns={isDoubleGrid ? 2 : 1} columns={columns}>
      {teams?.map((value, idx) => {
        const linkTo = getInnerLink(value)
        const isOwner = value?.ownersIDs?.includes(profile?.accountId ?? '')
        return (<ChannelCard
          team={value as any}
          isEditable={isOwner}
          isDeletable={false}
          isRejected={false}
          onTeamClick={onTeamClick}
          isModal={false}
          key={value.teamId}
          linkPrefix={linkPrefix ? linkPrefix : undefined}
          linkTo={linkTo}
          entityType={entityType}
          {...value}
          {...handlers}
          contextName={contextName}
        />);
      })}
    </GridWrapperNew>
  )
}

import React, { FC, PropsWithChildren, ReactNode, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { ProjectCard } from '../projectCard';
import { DesignerCard } from '../designerCard';
import styled, { css } from 'styled-components';
import { IProjectLight } from '../../common';
import { ProjectEvents } from '../../helpers/projectEvents';
import { LayoutConst } from '../../../core';
import ProjectCardNew from '../projectCard/projectCardNew';
import { useRouteMatch as useRouteMatchOrigin } from "react-router-dom";
import { LinkTo } from "../../constants/linkTo";
import useIsDoubleGrid from "../../hooks/useIsDoubleGrid";
import SortableList, { SortableItem } from 'react-easy-sort';
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import { BookEvents } from '_deziiign/books/core/components/helper/bookEvents';
import { BookCard } from '_deziiign/books/core/components/bookCard';
import { computeBook, computeBookProject } from '_deziiign/books/core/components/helper/types/computed/ComputedBook';
import { ProjectDelegate } from 'project-delegate';
import TeamCard from '../TeamCard/TeamCard';
import { ComputedTeam } from 'shared/helpers/types/computed/ComputedTeam';
import { DesignerCardNew } from "../designerCard/designerCard";
import { ItemType } from 'shared/constants/itemType';
import { isServer } from 'shared/constants/isServer';
import { useRouteMatchSsr } from 'shared/hooks/useRouteMatchSsr';
import { Team } from '@brg/api';
import ChannelCard from '../ChannelCard/ChannelCard';
import AdBlockCard, { getAdBlocks, IAdBlock } from '../AdBlockCard';
import { interleaveAdBlocks } from './interleaveAdBlocks';
import { useProfile } from '@brg/auth';
import { getTeamLink } from 'shared/helpers/getTeamLink';
import { MEDIA } from '@brg/ui';


const useRouteMatch = isServer ? useRouteMatchSsr : useRouteMatchOrigin

export interface GridProps {
  isLoading?: boolean;
  k?: number;
  mobileColumns?: number;
  columns?: number;
  isOpaCard?: boolean;
  inDetailCard?: boolean;
}

export const GridWrapper = styled.div.attrs({ className: 'grid-w' }) <{ mobileColumns: number }>`
  display: grid;
  grid-template-columns: repeat(4, 270px);
  gap: 24px;

  @media (max-width: ${LayoutConst.screen.l}px) {
    display: grid;
    grid-template-columns: repeat(4, 221.25px);
    gap: 19.6px;
  }

  @media (max-width: 940px) {
    display: grid;
    grid-template-columns: repeat(
      ${(props) => props.mobileColumns},
      ${(props) => (props.mobileColumns === 2 ? 'calc(50vw - 24px)' : '100%')}
    );
    row-gap: 19.6px;
    column-gap: ${(props) => (props.mobileColumns === 2 ? '16px' : '0')};
  }
`;


//todo переделать, плохо читается
// вообще не читается ):
export const GridWrapperNew = styled.div.attrs({ className: 'grid-w grid-wrapper-new' }) <{
  isLoading?: boolean,
  inDetailCard?: boolean,
  largeMobOffset?: boolean,
  banFollow?: boolean,
  withoutPaddingBottom?: boolean,
  hasLastProjectMoreAuthors?: boolean,
  mobileColumns?: number,
  isDesignersGrid?: boolean,
  isOpaCard?: boolean,
  columns?: number,
  itemType?: ItemType,
  isAgeytomesh?: boolean,
  isProfile?: boolean,
  isFixedHeight?: boolean,
  isSuperPuperGames?: boolean
}>`
  display: grid;
  justify-content: center;
  justify-items: center;
  grid-template-columns: repeat(${(props) => props.columns ?? 4}, ${LayoutConst.projectCard.l.w + 'px'});
  gap: ${({ inDetailCard }) => inDetailCard ? '32px 24px' : LayoutConst.projectCardGap.l + 'px'};
  grid-auto-flow: dense;
  padding-bottom: ${(props) => props.isProfile ? '0px' : '24px'} !important;
  // padding-top: ${(props) => props.isProfile || props.itemType === ItemType.showcase ? '0px' : '24px'};
  overflow: visible;
  // overflow-y: hidden;
  ${p => p.isFixedHeight && 'height: calc(458px * 5 + 24px * 4);'}

  ${({ banFollow }) => banFollow && css`
      a {
        pointer-events: none;
      }
  `};

  ${({ isOpaCard }) => isOpaCard ? css`
    place-items: flex-start;
  ` : null};

  ${({ columns, itemType, inDetailCard }) => {
    switch (itemType) {
      case ItemType.book:
        return css`
          grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.l.w + 'px'});
          gap: ${LayoutConst.projectCardGap.l + 'px'};
          padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
        `;

      case ItemType.showcase:
        return css`
          grid-template-columns: repeat(${columns ?? 4}, 564px);
          gap: ${LayoutConst.projectCardGap.l + 'px'};
          padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
        `;

      case ItemType.mapItem:
        return css`
          grid-template-columns: repeat(${columns ?? 2}, 1fr);
          gap: ${LayoutConst.projectCardGap.tablet + 'px'};
          padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
        `;

      case ItemType.other:
        return css`
          grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.l.w + 'px'});
          gap: ${inDetailCard ? '40px 24px' : LayoutConst.projectCardGap.l + 'px'};
          padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
        `;

      default:
        return null;
    }
  }}

  @media (max-width: ${LayoutConst.screen.mac13 + 'px'}), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: auto;
    ${({ columns, itemType }) => (itemType && [ItemType.book, ItemType.competition, ItemType.other]?.includes(itemType)) ? css`
      grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.m.w + 'px'});
      gap: ${LayoutConst.projectCardGap.l + 'px'};
      padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
    ` : null};

    ${({ inDetailCard }) => inDetailCard && css`
      gap: 32px 24px; 
    `};
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    // gap: ${LayoutConst.projectCardGap.l + 'px'} ;
    gap: 16px;
    padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};

     ${({ columns, itemType }) => {
    switch (itemType) {
      case ItemType.book:
      case ItemType.competition:
      case ItemType.other:
        return css`
            grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.m.w + 'px'});
     
            padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
          `;
      case ItemType.showcase:
        return css`
            grid-template-columns: repeat(${columns ?? 4}, 450px);
          `;
      default:
        return css`
            grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.projectCard.s.w + 'px'});          
          `
    }
  }};


  @media (max-width: ${LayoutConst.screen.l}px) {
    ${({ columns, itemType }) => {
      if (itemType === ItemType.mapItem) {
        return css`
                  gap: 24px;
                  grid-template-columns: repeat(${columns ?? 4}, 1fr);
                `;
      }
    }
  }
   
    ${({ isSuperPuperGames }) => isSuperPuperGames && css`
        gap: 16px; 
    `};
    
    ${({ isDesignersGrid }) => isDesignersGrid ? css`
      column-gap: ${LayoutConst.projectCardGap.tablet + 'px'};
      row-gap: ${LayoutConst.projectCardGap.l + 8 + 'px'};
    ` : null}

    ${({ inDetailCard }) => inDetailCard && css`
      gap: 24px; 
    `};
  }

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    grid-template-columns: repeat(${(props) => props.columns ?? 4}, ${LayoutConst.projectCard.tablet.w + 'px'});
    gap: ${({ inDetailCard }) => inDetailCard ? '24px' : LayoutConst.projectCardGap.tablet + 'px'};
    padding-bottom: ${LayoutConst.projectCardGap.m + 'px'};

    ${({ columns, itemType }) => (itemType && !!['competition', 'book', 'other']?.includes(itemType)) ? css`
    grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.m.w + 'px'});
    gap: ${LayoutConst.projectCardGap.l + 'px'};
    padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
    
    ` : itemType === ItemType.showcase ? css`
    grid-template-columns: repeat(${columns ?? 4}, 100%);
    ` : itemType === ItemType.mapItem ? css`
      grid-template-columns: repeat(${columns ?? 4}, 1fr);
    `: null}

    ${({ isDesignersGrid }) => isDesignersGrid ? css`
      column-gap: ${LayoutConst.projectCardGap.tablet + 'px'};
      row-gap: ${LayoutConst.projectCardGap.l + 8 + 'px'};
    ` : null}
  }


  @media (max-width: ${LayoutConst.screen.md + 'px'}) {
    ${({ itemType, columns }) => {
    switch (itemType) {
      case ItemType.mapItem:
        return css`
            grid-template-columns: repeat(${columns ?? 4}, 1fr);
            gap: ${LayoutConst.projectCardGap.tablet + 'px'};
          `;
      case ItemType.competition:
        return css`
            grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.projectCard.s.w + 'px'});
            gap: ${LayoutConst.projectCardGap.s + 'px'};
            padding-bottom: ${LayoutConst.projectCardGap.s + 'px'};
          `;
      case ItemType.book:
        return css`
            grid-template-columns: repeat(${columns ?? 4}, calc((100% - 48px) / 4));
            gap: 16px;
            padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
          `;
      case ItemType.other:
        return css`
            grid-template-columns: repeat(${columns ?? 4}, 1fr);
            gap: ${LayoutConst.projectCardGap.s + 'px'};
            padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
          `;
      default:
        return null;
    }
  }}
  }

  @media ${MEDIA.MOBILE} {
    ${({ columns, itemType }) => (itemType && !!['competition']?.includes(itemType)) ? css`
      //grid-template-columns: repeat(${columns ?? 4}, calc(25vw - 22px));
      grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.s.w + 'px'});
      gap: 16px;
      padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
  
  ` : null}

  ${({ columns, itemType }) => (itemType && !!['book']?.includes(itemType)) ? css`
      // grid-template-columns: repeat(${columns ?? 4}, calc(25vw - 10px - 16px + ${LayoutConst.projectCardGap.l / (columns ?? 4)}px));
      grid-template-columns: repeat(${columns ?? 4}, calc((100% - 48px) / 4));
      gap: 16px;
      padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
  
  ` : null}

    ${({ isDesignersGrid, columns, mobileColumns }) => isDesignersGrid ? css`
      column-gap: ${LayoutConst.projectCardGap.tablet + 'px'};
      row-gap: ${LayoutConst.projectCardGap.l + 8 + 'px'};
      ${mobileColumns === 2 ? css`
        grid-template-columns: repeat(2, minmax(0, 1fr));
      ` : css`
        grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.s.w + 'px'});
      `}
    ` : null}
  }
  ${({ hasLastProjectMoreAuthors }) => hasLastProjectMoreAuthors ? css`
    @media (max-width: ${LayoutConst.screen.md + 'px'}) {
      margin-bottom: 48px;
    }
    @media (max-width: ${LayoutConst.screen.s + 'px'}) {
      margin-bottom: 0;
      padding-bottom: 0 !important;
    }
` : null}

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {

    ${({ isOpaCard, columns, itemType }) => isOpaCard ? css`
      grid-template-columns: repeat(2, 362px);
      gap: 16px;
    `
    : itemType === ItemType.other ? css`
      grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.projectCard.xs.w + 'px'});
      gap: ${16 + 'px'};
      padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
    ` : itemType === ItemType.book ? css`
      grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.projectCard.xs.w + 'px'});
      gap: ${LayoutConst.projectCardGap.tablet + 'px'};
      padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
    ` : css`
      grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.projectCard.xs.w + 'px'});
      gap: ${LayoutConst.projectCardGap.tablet + 'px'};
      padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
    `};

    ${({ isDesignersGrid, columns, mobileColumns }) => isDesignersGrid ? css`
      column-gap: ${LayoutConst.projectCardGap.tablet + 'px'};
      row-gap: ${LayoutConst.projectCardGap.l + 8 + 'px'};
      ${mobileColumns === 2 ? css`
        grid-template-columns: repeat(2, minmax(0, 1fr));
      ` : css`
        grid-template-columns: repeat(${columns ?? 4}, ${LayoutConst.bookCard.s.w + 'px'});
      `}
    ` : null}
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
    ${({ isOpaCard, columns, itemType, mobileColumns, isDesignersGrid }) =>
    isDesignersGrid && mobileColumns === 2 ? css`
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: ${LayoutConst.projectCardGap.s + 'px'};
  ` : itemType === ItemType.showcase ? css`
    grid-template-columns: repeat(${columns ?? 4}, 100%);
  `: itemType === ItemType.other ? css`
    grid-template-columns: repeat(2, calc(50vw - 15px));
    gap: ${LayoutConst.projectCardGap.s + 'px'};
    padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
  ` : itemType === ItemType.competition ? css`
      grid-template-columns: repeat(
      ${mobileColumns},
      ${mobileColumns === 2 ? 'calc(50vw - 15px)' : '100%'}
    );
    gap: ${mobileColumns === 2 ? 16 : 24}px 10px;
  ` : css`
    grid-template-columns: repeat(
      ${mobileColumns},
      ${mobileColumns === 2 ? 'calc(50vw - 15px)' : '100%'}
    );
    gap: ${mobileColumns === 2 ? 16 : 24}px 10px;
    `}
    justify-content: center;
    justify-items: center;
  }

  ${({ largeMobOffset }) => largeMobOffset && css`
    padding-bottom: 100px !important;
  `};
  
  ${({ withoutPaddingBottom }) => withoutPaddingBottom && css`
    padding-bottom: 0!important;
  `}
`;

export const SortableGridWrapperNew = styled.div<{ mobileColumns?: number, itemType?: string }>`

  .sortable-projects-grid {
    user-select: none;
    display: grid;
    ${({ itemType }) => itemType === ItemType.book ? css`
      grid-template-columns: repeat(4, ${LayoutConst.bookCard.l.w + 'px'});
      gap: ${LayoutConst.projectCardGap.l + 'px'};
    ` : css`
      grid-template-columns: repeat(4, ${LayoutConst.projectCard.l.w + 'px'});
      gap: ${LayoutConst.projectCardGap.l + 'px'};
    `}

    .sortable-projects-grid-item {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      color: white;
      cursor: grab;
      user-select: none;
      z-index: 1;
    }

    .sortable-projects-grid-dragged {
      opacity: 0.5;
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ itemType }) => itemType === ItemType.book ? css`
    .sortable-projects-grid {
      grid-template-columns: repeat(4, ${LayoutConst.bookCard.m.w + 'px'});
      gap: ${LayoutConst.projectCardGap.l + 'px'};
    }
    ` : null}
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    .sortable-projects-grid {
      ${({ itemType }) => itemType === ItemType.book ? css`
        grid-template-columns: repeat(4, ${LayoutConst.bookCard.m.w + 'px'});
        gap: ${LayoutConst.projectCardGap.l + 'px'};
      ` : css`
        grid-template-columns: repeat(4, ${LayoutConst.projectCard.m.w + 'px'});
        gap: ${LayoutConst.projectCardGap.tablet + 'px'};
      `}
    }
  }

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    .sortable-projects-grid {
      ${({ itemType }) => itemType === ItemType.book ? css`
      grid-template-columns: repeat(4, ${LayoutConst.bookCard.m.w + 'px'});
      gap: ${LayoutConst.projectCardGap.l + 'px'};
    ` : css`
      grid-template-columns: repeat(4, ${LayoutConst.projectCard.m.w + 'px'});
      gap: ${LayoutConst.projectCardGap.m + 'px'};
    `}
    }
  }

  @media (max-width: ${LayoutConst.screen.md + 'px'}) {
    .sortable-projects-grid {
      ${({ itemType }) => itemType === ItemType.book ? css`
      grid-template-columns: repeat(4, ${LayoutConst.bookCard.m.w + 'px'});
      gap: ${LayoutConst.projectCardGap.l + 'px'};
    ` : css`
      grid-template-columns: repeat(4, ${LayoutConst.projectCard.s.w + 'px'});
      gap: ${LayoutConst.projectCardGap.s + 'px'};
    `}
    } 
  }

  @media ${MEDIA.MOBILE} {
    .sortable-projects-grid {
      ${({ itemType }) => itemType === ItemType.book ? css`
      grid-template-columns: repeat(4, ${LayoutConst.bookCard.s.w + 'px'});
      gap: ${LayoutConst.projectCardGap.m + 'px'};
    ` : css`
      grid-template-columns: repeat(4, ${LayoutConst.projectCard.s.w + 'px'});
      gap: ${LayoutConst.projectCardGap.s + 'px'};
    `}
    } 
  }
  @media (max-width: ${LayoutConst.screen.s + 'px'}) {
    .sortable-projects-grid {
      ${({ itemType, mobileColumns }) => itemType === ItemType.book ? css`
        grid-template-columns: repeat(${mobileColumns}, ${(mobileColumns === 2 ? 'calc(50vw - 15px)' : '100%')});
        gap: ${mobileColumns === 2 ? 16 : 24}px 10px;
      ` : css`
        grid-template-columns: repeat(4, ${LayoutConst.projectCard.s.w + 'px'});
        gap: ${LayoutConst.projectCardGap.s + 'px'};
      `}
    }
  }

`;

export const GridHseNews = styled.div`
    display: grid;
    grid-template-columns: repeat(3, calc((100% - ${LayoutConst.projectCardGap.l * 2 + 'px'} ) / 3 ));
    gap: ${LayoutConst.projectCardGap.l + 'px'};

    @media (min-width: 320px) {
        grid-template-columns: repeat(1, calc(100vw - 32px));
        gap: 24px;
    }

    @media (min-width: ${LayoutConst.screen.s + 'px'}) {
        grid-template-columns: repeat(2, calc((100% - ${LayoutConst.projectCardGap.s + 'px'}) / 2 ));
        gap: ${LayoutConst.projectCardGap.s + 'px'};
    }

    @media (min-width: ${LayoutConst.screen.m + 'px'}) {
        grid-template-columns: repeat(3, calc((100% - ${LayoutConst.projectCardGap.m * 2 + 'px'} ) / 3 ));
        gap: ${LayoutConst.projectCardGap.m + 'px'};
    }

    @media (min-width: ${LayoutConst.screen.l + 'px'}) {
        grid-template-columns: repeat(3, calc((100% - ${LayoutConst.projectCardGap.l * 2 + 'px'} ) / 3 ));
        gap: ${LayoutConst.projectCardGap.l + 'px'};
    }
`;

/**
 * **ProjectsGrid** - сетка проектов. Содержит переключение isLoading для отображения UX анимации
 *
 * @param mobileColumns
 * @param isLoading
 * @param children
 * @param projects
 * @param k
 * @param isEditable
 * @param handlers
 */
export const ProjectsGrid: FC<
  React.PropsWithChildren<GridProps & { projects?: IProjectLight[]; isEditable?: (project: IProjectLight) => boolean } & ProjectEvents>
> = ({ mobileColumns, isLoading, children, projects, k, isEditable, ...handlers }) => {
  if (isLoading) {
    return (
      <GridWrapper mobileColumns={mobileColumns ?? 1}>
        {Array(k ?? 8)
          .fill('')
          .map((value, index) => (
            <ProjectCard key={index} isLoading={true} />
          ))}
      </GridWrapper>
    );
  }
  return (
    <GridWrapper mobileColumns={mobileColumns ?? 1}>
      {projects
        ? projects.map((value) => (
          <ProjectCard isEditable={isEditable?.(value)} key={value.identifier} {...value} {...handlers} />
        ))
        : null}
      {children}
    </GridWrapper>
  );
};

type ProjectsGridNewPropsT = ProjectEvents & BookEvents & GridProps & {
  isDraggable?: boolean;
  onSortEnd?: (projectId: string, newIndex: number) => void;
  isModal?: boolean;
  projects?: IProjectLight[];
  isEditable?: (project: IProjectLight) => boolean;
  isDeletable?: (project: IProjectLight) => boolean;
  isRemovableFromBook?: boolean;
  onRemoveFromBook?: (projectId: string) => void;
  isCanNotParticipate?: boolean;
  onNotParticipate?: (projectId: string) => void;
  onProjectClick?: (project: IProjectLight, e?: any) => void;
  linkPrefix?: any;
  isAgeytomesh?: boolean;
  withoutRepost?: boolean;
  withoutPaddingBottom?: boolean;
  isCanNotBeDraft?: boolean;
  isCanNotBeBookmark?: boolean;
  itemType?: string;
  banFollow?: boolean;
  largeMobOffset?: boolean;
  isMobileMoreVisible?: boolean;
  isFixedHeight?: boolean;
  isSuperPuperGames?: boolean;
  currentTeam?: Team;
  currentTab?: string;
  forceOneColumn?: boolean;
  showAnnotations?: boolean;
  isHeadCommentsVisibleLocal?: boolean;
  currentCompetitionId?: string;
};

type TeamGridProps = ProjectEvents & GridProps & {
  teams: ComputedTeam[];
  isDraggable?: boolean;
  onSortEnd?: (teamId: string, newIndex: number) => void;
  isEditable?: boolean;
  isDeletable?: (project: Team) => boolean;
  linkPrefix?: any;
  onTeamClick?: (team?: ComputedTeam, e?: any, openInMedia?: boolean) => void;
  hasLinks?: boolean;
  contextName?: string;
  entityType?: string;
  isFixedHeight?: boolean;
  currentTeam?: Team;
  isMe?: boolean;
  currentTab?: string;
  isOuterOrganizationShowcase?: boolean;
}

type ChannelsGridProps = ProjectEvents & GridProps & {
  teams: ComputedTeam[];
  isDraggable?: boolean;
  onSortEnd?: (teamId: string, newIndex: number) => void;
  isEditable?: boolean;
  isDeletable?: (project: Team) => boolean;
  linkPrefix?: any;
  onTeamClick?: (team?: ComputedTeam, e?: any, openInMedia?: boolean) => void;
  hasLinks?: boolean;
  contextName?: string;
  entityType?: string;
  isFixedHeight?: boolean;
  isParticipant?: boolean;
}

export const ProjectsGridNew: FC<PropsWithChildren<ProjectsGridNewPropsT>> = ({
  mobileColumns,
  forceOneColumn,
  columns,
  isLoading,
  children,
  projects,
  k,
  isEditable,
  isDeletable,
  isRemovableFromBook,
  onRemoveFromBook,
  isCanNotParticipate,
  isMobileMoreVisible,
  onNotParticipate,
  onProjectClick,
  isModal,
  isDraggable,
  onSortEnd,
  isCanNotBeDraft,
  isCanNotBeBookmark,
  withoutRepost,
  linkPrefix,
  isAgeytomesh,
  withoutPaddingBottom,
  largeMobOffset,
  itemType,
  banFollow,
  isFixedHeight,
  isSuperPuperGames,
  currentTeam,
  currentTab,
  showAnnotations,
  isHeadCommentsVisibleLocal,
  currentCompetitionId,
  ...handlers
}) => {
  const isDoubleGrid = useIsDoubleGrid({ forceOneColumn });
  const [projectsSource, setProjectsSource] = useState<IProjectLight[]>([]);
  const isProfile = !!useRouteMatch(LinkTo.designer);
  const hasLastProjectMoreAuthors = projectsSource?.[projectsSource.length - 1]?.coAuthorIds.length > 0

  useEffect(() => {
    setProjectsSource(projects ?? []);
  }, [projects])

  const adBlocks = useMemo<IAdBlock[]>(
    () => (!currentTeam || isProfile ? [] : getAdBlocks(currentTeam as any, currentTab)),
    [currentTeam, currentTab, isProfile],
  );

  const renderAdCard = useCallback((block: IAdBlock, key: string) => (
    <AdBlockCard
      key={key}
      team={currentTeam}
      itemType={itemType}
      currentTab={currentTab}
      fullWidth={showAnnotations}
      adBlock={block}
    />
  ), [currentTeam, itemType, currentTab, showAnnotations]);

  const onProjectsSortEnd = useCallback((oldIndex: number, newIndex: number): void => {
    const project = projectsSource[oldIndex];
    setProjectsSource(arrayMoveImmutable(projectsSource, oldIndex, newIndex));
    onSortEnd?.(project.identifier, newIndex);
  }, [projectsSource, onSortEnd]);

  if (isLoading) {
    return (
      <GridWrapperNew isProfile={isProfile} isLoading={isLoading} mobileColumns={isDoubleGrid ? 2 : 1} columns={columns} itemType={itemType as any}>
        {Array(k === undefined ? 8 : k).fill('').map((_, index) => (
          <ProjectCardNew key={index} isLoading={isLoading} itemType={itemType} />
        ))}
      </GridWrapperNew>
    );
  }

  if (isDraggable) {
    return (
      <SortableGridWrapperNew mobileColumns={isDoubleGrid ? 2 : 1} itemType={itemType}>
        <SortableList onSortEnd={onProjectsSortEnd} className="sortable-projects-grid" draggedItemClassName="sortable-projects-grid-dragged">
          {projectsSource?.map((value) => (
            <SortableItem key={value.identifier} >
              <div className="sortable-projects-grid-item">
                {!value.isBook ?
                  <ProjectCardNew
                    project={value as any}
                    isLoading={isLoading}
                    isEditable={isEditable?.(value)}
                    isDeletable={isDeletable?.(value)}
                    isRemovableFromBook={isRemovableFromBook}
                    onProjectClick={onProjectClick ? (projectId?: string, e?: any) => onProjectClick(value, e) : undefined}
                    isModal={isModal}
                    withoutRepost={withoutRepost}
                    isMobileMoreVisible={isMobileMoreVisible}
                    isRejected={ProjectDelegate.isRejectedProject(value)}
                    isHeadCommentsVisibleLocal={isHeadCommentsVisibleLocal}
                    key={value.identifier}
                    onRemoveFromBook={onRemoveFromBook}
                    linkPrefix={linkPrefix ? linkPrefix : undefined}
                    isCanNotParticipate={isCanNotParticipate}
                    isCanNotBeDraft={isCanNotBeDraft}
                    isCanNotBeBookmark={isCanNotBeBookmark}
                    onNotParticipate={onNotParticipate}
                    itemType={itemType}
                    {...value}
                    {...handlers}
                  /> :
                  // @ts-ignore
                  <BookCard
                    book={computeBookProject(value as any) as any}
                    key={value.identifier}
                    {...computeBook(computeBookProject(value as any))}
                    isCanNotParticipate={isCanNotParticipate}
                    isCanNotBeDraft={isCanNotBeDraft}
                    itemType={itemType}
                    onNotParticipate={onNotParticipate}
                    isCanNotBeBookmark={isCanNotBeBookmark}
                  />}
              </div>
            </SortableItem>
          ))}
          {children}
        </SortableList>
      </SortableGridWrapperNew>
    );
  }

  const mobileColumnsWrapper = showAnnotations ? 2 :
    isDoubleGrid ? 2 : 1

  const hasProjectsProp = (projectsSource?.length ?? 0) > 0;
  const gridItems: ReactNode[] = hasProjectsProp
    ? (projectsSource ?? []).map((value) => (!value.isBook ? (
      <ProjectCardNew
        isLoading={isLoading}
        project={value as any}
        isEditable={isEditable?.(value)}
        isDeletable={isDeletable?.(value)}
        isHeadCommentsVisibleLocal={isHeadCommentsVisibleLocal}
        currentCompetitionId={currentCompetitionId}
        withoutRepost={withoutRepost}
        isRejected={ProjectDelegate.isRejectedProject(value)}
        onProjectClick={onProjectClick ? (_projectId?: string, e?: any) => onProjectClick(value, e) : undefined}
        isModal={isModal}
        isMobileMoreVisible={isMobileMoreVisible}
        key={value.identifier}
        linkPrefix={linkPrefix ? linkPrefix : undefined}
        isCanNotParticipate={isCanNotParticipate}
        onNotParticipate={onNotParticipate}
        isCanNotBeDraft={isCanNotBeDraft}
        isCanNotBeBookmark={isCanNotBeBookmark}
        itemType={itemType}
        onUpdate={handlers.onUpdate}
        {...value}
        {...handlers}
      />
    ) : (
      // @ts-ignore
      <BookCard
        book={computeBookProject(value as any) as any}
        key={value.identifier}
        {...computeBook(computeBookProject(value as any))}
        isCanNotParticipate={isCanNotParticipate}
        onNotParticipate={onNotParticipate}
        isCanNotBeDraft={isCanNotBeDraft}
        itemType={itemType}
        onUpdate={handlers.onUpdate}
      />
    )))
    : React.Children.toArray(children);

  return (
    <GridWrapperNew
      largeMobOffset={largeMobOffset}
      isProfile={isProfile}
      banFollow={banFollow}
      withoutPaddingBottom={withoutPaddingBottom}
      hasLastProjectMoreAuthors={hasLastProjectMoreAuthors}
      mobileColumns={mobileColumnsWrapper}
      columns={columns}
      isAgeytomesh={isAgeytomesh}
      itemType={itemType as any}
      isSuperPuperGames={isSuperPuperGames}
    >
      {interleaveAdBlocks(gridItems, adBlocks, renderAdCard)}
      {hasProjectsProp ? children : null}
    </GridWrapperNew>
  );
};

export const NewsGrid: FC<React.PropsWithChildren<GridProps & { isEditable?: (project: IProjectLight) => boolean } & ProjectEvents>> = ({ isLoading, children, k }) => {
  if (isLoading) {
    return (
      <GridHseNews>
        {Array(k ?? 3)
          .fill('')
          .map((value, index) => (
            <ProjectCardNew key={index} isLoading={true} />
          ))}
      </GridHseNews>
    );
  }
  return (
    <GridHseNews>
      {children}
    </GridHseNews>
  );
};

export const DesignersGrid: FC<React.PropsWithChildren<GridProps>> = ({ mobileColumns, isLoading, children, k }) => {
  if (isLoading) {
    return (
      <GridWrapper mobileColumns={mobileColumns ?? 1}>
        {Array(k ?? 8)
          .fill('')
          .map((value, index) => (
            <DesignerCard key={index} isLoading={true} />
          ))}
      </GridWrapper>
    );
  }
  return <GridWrapper mobileColumns={mobileColumns ?? 1}>{children}</GridWrapper>;
};

export const DesignersGridNew: FC<React.PropsWithChildren<GridProps>> = ({ mobileColumns, isLoading, isOpaCard, children, inDetailCard, k }) => {
  const isProfile = !!useRouteMatch(LinkTo.designer);
  if (isLoading) {
    return (
      <GridWrapperNew isDesignersGrid mobileColumns={mobileColumns} isOpaCard={isOpaCard}>
        {Array(k ?? 8)
          .fill('')
          .map((value, index) => (
            <DesignerCardNew key={index} isLoading={true} isOpaCard={isOpaCard} />
          ))}
      </GridWrapperNew>
    );
  }
  return <GridWrapperNew isProfile={isProfile} isDesignersGrid inDetailCard={inDetailCard} mobileColumns={mobileColumns} isOpaCard={isOpaCard}>{children}</GridWrapperNew>;
};

export const TeamGrid: FC<TeamGridProps> = ({
  teams: teamsRaw,
  contextName,
  isDraggable,
  onSortEnd,
  isEditable,
  isDeletable,
  onTeamClick,
  linkPrefix,
  isMe,
  hasLinks,
  columns,
  entityType,
  isFixedHeight,
  isLoading,
  currentTeam,
  currentTab,
  isOuterOrganizationShowcase,
  onUpdate,
  ...handlers
}) => {
  const isDoubleGrid = useIsDoubleGrid();
  const isProfile = !!useRouteMatch(LinkTo.designer);
  const isMadeByMediiia = !!useRouteMatch('/made_by_mediiia');
  const teams = useMemo(() => {
    return teamsRaw;
  }, [isMadeByMediiia, teamsRaw]);

  const adBlocks = useMemo<IAdBlock[]>(
    () => (!currentTeam || isProfile ? [] : getAdBlocks(currentTeam as any, currentTab)),
    [currentTeam, currentTab, isProfile],
  );

  if (isLoading) {
    return <ProjectsGridNew isLoading />
  }

  const renderAdCard = (block: IAdBlock, key: string) => (
    <AdBlockCard
      key={key}
      team={currentTeam}
      itemType={entityType}
      currentTab={currentTab}
      adBlock={block}
    />
  );

  const teamItems = (teams ?? []).map((team) => (
    <TeamCard
      team={team as any}
      isEditable={false}
      isMe={isMe}
      isDeletable={false}
      isRejected={false}
      onTeamClick={onTeamClick}
      isModal={false}
      disableHover={team?.hiddenHover}
      key={team.teamId}
      linkPrefix={linkPrefix ? linkPrefix : undefined}
      linkTo={getTeamLink(team, hasLinks)}
      entityType={entityType}
      {...team}
      {...handlers}
      contextName={contextName}
      isOuterOrganizationShowcase={isOuterOrganizationShowcase}
      isProfile={isProfile}
      onUpdate={onUpdate}
    />
  ));

  return (
    <GridWrapperNew isFixedHeight={isFixedHeight} isProfile={isProfile} mobileColumns={isDoubleGrid ? 2 : 1} columns={columns}>
      {interleaveAdBlocks(teamItems, adBlocks, renderAdCard)}
    </GridWrapperNew>
  )
}

//todo чем отличается от TeamGrid?
export const ChannelsGrid: FC<ChannelsGridProps> = ({
  teams: teamsRaw,
  contextName,
  isDraggable,
  isParticipant,
  onSortEnd,
  isEditable,
  isDeletable,
  onTeamClick,
  linkPrefix,
  hasLinks,
  columns,
  entityType,
  isFixedHeight,
  ...handlers
}) => {
  const isDoubleGrid = useIsDoubleGrid();
  const isProfile = !!useRouteMatch(LinkTo.designer);
  const isMadeByMediiia = !!useRouteMatch('/made_by_mediiia');
  const profile = useProfile();

  const teams = useMemo(() => {
    return teamsRaw;
  }, [isMadeByMediiia, teamsRaw]);

  const getInnerLink = useCallback((team: ComputedTeam) => {
    return process.env.REACT_APP_URL_MEDIIIA_COM + '/teams/' + team?.teamId
  }, [hasLinks])

  return (
    <GridWrapperNew isFixedHeight={isFixedHeight} isProfile={isProfile} mobileColumns={isDoubleGrid ? 2 : 1} columns={columns}>
      {teams?.map((value, idx) => {
        const linkTo = getInnerLink(value)
        const isOwner = value?.ownersIDs?.includes(profile?.accountId ?? '')
        return (<ChannelCard
          team={value as any}
          isEditable={isOwner}
          isDeletable={false}
          isRejected={false}
          onTeamClick={onTeamClick}
          isModal={false}
          key={value.teamId}
          linkPrefix={linkPrefix ? linkPrefix : undefined}
          linkTo={linkTo}
          entityType={entityType}
          {...value}
          {...handlers}
          contextName={contextName}
        />);
      })}
    </GridWrapperNew>
  )
}

